var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 38,
    viewBox: "0 0 208 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.61262 33.6011L0 8.12084C0 0.193648 4.40841 -0.466951 6.61262 0.193648H202.116C208.556 0.64663 208.441 5.66718 207.579 8.12084L200.679 33.6011C200.909 36.9985 196.366 37.8478 194.066 37.8478H14.0878C9.94768 38.7538 7.3793 35.3942 6.61262 33.6011Z",
    fill: "url(#paint0_linear_458_9)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_458_9",
    x1: 73,
    y1: -0.00000626042,
    x2: 135,
    y2: 38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D70D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03AEF3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector2);
export default __webpack_public_path__ + "static/media/Vector-2.0233e289220d90206f0c182eee5d81ec.svg";
export { ForwardRef as ReactComponent };